<script>
import { mapState } from "vuex";
import {EF_TRACKING_URL} from "@/paths/constants";

export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: null,
      feet: "",
      feetError: false,
      emptyFeetError: false,
      invalidFeetError: false,
      inches: "",
      inchesError: false,
      emptyInchesError: false,
      invalidInchesError: false,
      inchesErrorMsg: "",
      heightString: "4 feet, 3 inches",
      height: 60,
    };
  },

  computed: {
    ...mapState([
      "fields",
      "fieldsFromUrl",
      "fieldsFromStorage"
      ]),
  },

  created() {
    if (this.prepare) {
      if ((this.fieldsFromUrl["height_feet"] !== '' && this.fieldsFromUrl["height_feet"] !== undefined)
          && (this.fieldsFromUrl["height_inches"] !== '' && this.fieldsFromUrl["height_inches"] !== undefined)
          && (this.fieldsFromUrl["height_feet_inches"] !== '' && this.fieldsFromUrl["height_feet_inches"] !== undefined)
      ) {
        this.feet = this.fieldsFromUrl["height_feet"];
        this.inches = this.fieldsFromUrl["height_inches"];
        this.totalInches = this.fieldsFromUrl["height_feet_inches"];
      } else if (this.fieldsFromStorage["height_feet"] !== undefined
          && this.fieldsFromStorage["height_inches"] !== undefined
          && this.fieldsFromStorage["height_feet_inches"] !== undefined
      ) {
        this.feet = this.fieldsFromStorage["height_feet"];
        this.inches = this.fieldsFromStorage["height_inches"];
        this.totalInches = this.fieldsFromStorage["height_feet_inches"];
      }

      const valid = this.validate();

      if (!this.totalInches) {
        this.totalInches = parseInt(this.feet) * 12 + parseInt(this.inches);
      }

      if (!valid) {
        this.$emit("show-this-step");
      } else {
        this.setAnswersAndGoToNext();
      }
    }
  },

  methods: {
    async setAnswer(answer) {
      this.loading = null;
      this.totalHeightInches();
      const valid = this.validate();
      if (!valid) return;
      this.loading = answer;
      this.setAnswersAndGoToNext();
      // await this.progressionTracking();
    },

    setAnswersAndGoToNext() {
      this.$store.dispatch("setAnswers", [
        {
          field: "height_feet",
          value: parseInt(this.feet),
        },
        {
          field: "height_inches",
          value: parseInt(this.inches),
        },
        {
          field: "height_feet_inches",
          value: this.totalInches,
        },
      ]);
      this.$emit("next-step");
    },

    validate() {
      const validFeet = this.validateFeet();
      const validInches = this.validateInches();
      const validTotalInches = this.validateTotalInches();

      if ((validFeet && validInches) || validTotalInches) return true;
    },

    validateFeet() {
      return this.feet.length !== 0 && (this.feet >= 3 && this.feet <= 7)
    },

    validateInches() {
      return this.inches.length !== 0 && (this.inches >= 0 && this.inches <= 11)
    },

    validateTotalInches() {
      return this.totalInches >= 36 && this.totalInches < 100
    },

    totalHeightInches() {
      this.totalInches  = parseInt(this.feet) * 12 + parseInt(this.inches);
    },

    async progressionTracking() {
      const eventID = "56"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}`)
    },

    handleChangeHeight() {
      let val = Number(this.height);

      const feet = Math.floor(val / 12);
      const inches = val % 12;

      this.heightString = `${feet}′`;
      this.heightString += ` ${inches}″`;
      this.feet = feet;
      this.inches = inches;
    },
  },
};
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question mb-3">What is your height?</h2>
        <form
          class="container is-max-widescreen"
          @submit.prevent="setAnswer('Continue')"
        >
          <h2 class="question pt-5">{{ heightString }}</h2>
          <b-field class="pt-4">
            <b-slider size="is-large" :min="36" :max="84" :step="1" :tooltip="false" v-model="height" rounded @input="handleChangeHeight"></b-slider>
          </b-field>
          <input
            type="submit"
            value="Continue"
            class="submitButton mt-3"
            :loading="loading === 'Continue'"
            :disabled="loading !== null"
          />
        </form>
      </div>
    </div>
  </div>
</template>
